import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/auth'

export async function apiFetch<T = unknown>(path: string, init: RequestInit = {}): Promise<T> {
  const authStore = useAuthStore()
  const { data: { session } } = await supabase.auth.getSession()

  const headers = new Headers(init.headers)
  headers.set('Content-Type', 'application/json')

  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`)
  }

  if (authStore.activeAccountId) {
    headers.set('X-Account-Id', authStore.activeAccountId)
  }

  const response = await fetch(`${import.meta.env.VITE_API_URL || window.location.origin}${path}`, {
    ...init,
    headers
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => null) as { message?: string; error?: string } | null
    throw new Error(errorBody?.message || errorBody?.error || `Request failed with status ${response.status}`)
  }

  if (response.status === 204) {
    return undefined as T
  }

  return response.json() as Promise<T>
}
